export default "__VITE_ASSET__D$aqAxt3__"